
<router-outlet></router-outlet>
<div ngStyle.xs="padding-inline:0" fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" fxLayoutGap="10"
  fxLayoutGap.xs="0" fxLayoutGap.sm="0" class="adver main_ads ">
  <div fxFlexAlign="center" class=" " fxLayoutAlign="center">
    <a href="https://bit.ly/3STIOhn" target="_blank" rel="noopener">
      <img loading="lazy" style="display: block; width: 100%;   margin:auto"
        src="https://cdn.newsfirst.lk/advertisements/31-01-2024/S24%20Series%20Pre-order%20banner_01_720%20x%2090%20(1).gif"
        alt="" /></a>
  </div>

</div>
